import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel from 'react-elastic-carousel';
import Item from '../components/SimpleItem';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "onnextstart"
    }}>{`onNextStart`}</h1>
    <h4 {...{
      "id": "onnextstart-will-pass-both-the-current-and-next-item-object"
    }}><inlineCode parentName="h4">{`onNextStart`}</inlineCode>{` will pass both the `}<strong parentName="h4">{`current`}</strong>{` and `}<strong parentName="h4">{`next`}</strong>{` `}<inlineCode parentName="h4">{`item-object`}</inlineCode>{`:`}</h4>
    <pre><code parentName="pre" {...{}}>{`(currentItem, nextItem) => {/*...*/}
`}</code></pre>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`item-object`}</inlineCode>{` has the shape of:`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`{
    item: {/* your item */},
    index: // the item's index number 
}
`}</code></pre>
    <Playground __position={0} __code={'<Carousel\n  itemsToShow={2}\n  onNextStart={(currentItem, nextItem) =>\n    alert(JSON.stringify(currentItem) + `\\n` + JSON.stringify(nextItem))\n  }\n>\n  <Item someProp=\"cool1\">1</Item>\n  <Item someProp=\"cool2\">2</Item>\n  <Item someProp=\"cool3\">3</Item>\n  <Item someProp=\"cool4\">4</Item>\n  <Item someProp=\"cool5\">5</Item>\n  <Item someProp=\"cool6\">6</Item>\n</Carousel>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Carousel itemsToShow={2} onNextStart={(currentItem, nextItem) => alert(JSON.stringify(currentItem) + `\n` + JSON.stringify(nextItem))} mdxType="Carousel">
    <Item someProp="cool1" mdxType="Item">1</Item>
    <Item someProp="cool2" mdxType="Item">2</Item>
    <Item someProp="cool3" mdxType="Item">3</Item>
    <Item someProp="cool4" mdxType="Item">4</Item>
    <Item someProp="cool5" mdxType="Item">5</Item>
    <Item someProp="cool6" mdxType="Item">6</Item>
    </Carousel>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      